export { default, useBodyScrollLock } from './Portal';
